export interface FetchArticleUsageStateType {
  state: number;
  stateString: string;
  stateName: string;
  className: string;
}

export class FetchArticleUsageStateTypes {
  static types: {[key: `${number}`]: FetchArticleUsageStateType} = {
    '0': {state: 0, stateString: '0', stateName: 'Neu', className: 'warning'},
    '1': {state: 1, stateString: '1', stateName: 'Bestand', className: 'default'},
  }

  static list: FetchArticleUsageStateType[] =
    Object.keys(FetchArticleUsageStateTypes.types).map(k => FetchArticleUsageStateTypes.types[k]);

  static getType(usageState?: number): FetchArticleUsageStateType {
    return FetchArticleUsageStateTypes.types[(usageState ?? 0).toString(10)];
  }
}
